var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47245 9.38672V30H0.000562504V9.38672H7.47245ZM18.7359 9.34863V10.5633C19.8266 9.85927 21.0844 9.45 22.9918 9.45C29.204 9.45 30 14.2729 30 18.4744V29.9994H22.4906V19.0489C22.4906 17.2072 21.8316 16.858 20.6132 16.858C19.4549 16.858 18.7359 17.226 18.7359 19.0489V29.9994H11.2264V9.34863H18.7359ZM3.73595 0C5.79729 0 7.47189 1.67647 7.47189 3.73592C7.47189 5.79537 5.79729 7.47184 3.73593 7.47184C1.6765 7.47184 0 5.79538 0 3.73591C0 1.67648 1.67648 0 3.73595 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.57fcd60055baa1989b832a03485700b2.svg";
export { ForwardRef as ReactComponent };